import { trackEvent } from 'modules/common/lib/amplitude/trackEvent'
import { useRouter } from 'next/router'
import { useCallback, useEffect } from 'react'
import { EnumCommonTrackingEvents } from '../lib/amplitude/events'

const MAX_ATTEMPTS = 10
const INTERVAL = 50

export const useTrackPageView = () => {
  const router = useRouter()

  const handleRouteChange = useCallback((path: string) => {
    trackEvent({
      eventType: EnumCommonTrackingEvents.PAGEVIEW,
      eventProperties: {
        path,
        url: window.location.href,
        pageTitle: document.title,
      },
    })
  }, [])

  // Handle navigation tracking while router path changes
  useEffect(() => {
    let attempts = 0

    const checkTitleAndTrack = () => {
      if (document.title || attempts >= MAX_ATTEMPTS) {
        handleRouteChange(router.asPath)
      } else {
        // Race condition: document.title might be defined on first render
        attempts++
        setTimeout(checkTitleAndTrack, INTERVAL)
      }
    }

    checkTitleAndTrack()
  }, [handleRouteChange, router.asPath])
}
